import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-565c02f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-4 text-base font-bold",
  "data-cy": "custom-input-title"
}
const _hoisted_2 = {
  key: 1,
  class: "flex-1 w-full my-2",
  "data-cy": "custom-input-table"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = { class: "text-left numberCol data-tr" }
const _hoisted_5 = { class: "text-left numberCol data-tr" }
const _hoisted_6 = {
  key: 2,
  "data-cy": "keine-maengel-vorhanden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_pdf_row_custom_input = _resolveComponent("pdf-row-custom-input")!
  const _component_pdf_color_codes = _resolveComponent("pdf-color-codes")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedCustomInput, (customInputPage, key) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      key: key,
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pdf_page_header, {
          immobilie: _ctx.immobilie,
          hzba: _ctx.ba,
          "tech-data": _ctx.techData,
          "is-hinweis-uebersicht": true,
          page: _ctx.pagesOptions.currentStartPage + key,
          "max-pages": _ctx.pagesOptions.maxPages,
          lang: _ctx.lang
        }, null, 8, ["immobilie", "hzba", "tech-data", "page", "max-pages", "lang"]),
        (key === 0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.t("hzba.pdf.weitereHinweise", 1, { locale: _ctx.lang })), 1))
          : _createCommentVNode("", true),
        (customInputPage && customInputPage.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.t("hzba.pdf.customInputBezeichnung", 1, { locale: _ctx.lang })), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.t("hzba.pdf.gewerk", 1, { locale: _ctx.lang })), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customInputPage, (customInputData, key) => {
                return (_openBlock(), _createBlock(_component_pdf_row_custom_input, {
                  key: key,
                  "custom-input-data": customInputData,
                  odd: key % 2 === 0
                }, null, 8, ["custom-input-data", "odd"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, "Keine weiteren Hinweise vorhanden.")),
        _createVNode(_component_pdf_color_codes, {
          class: "ml-1",
          lang: _ctx.lang
        }, null, 8, ["lang"])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}